import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import scenariosReducer from './slices/scenariosSlice';
import analysisReducer from './slices/analysisSlice';
import chatReducer from './slices/chatSlice';
import uiReducer from './slices/uiSlice';


export const store = configureStore({
  reducer: {
    scenarios: scenariosReducer,
    analysis: analysisReducer,
    chat: chatReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {

        ignoredActions: ['analysis/addTraceEvent'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
